import TextField from './src/textField';

TextField.install = function(Vue) {
  Vue.component(TextField.name, TextField);
};

export default TextField;
